import React from 'react'

function AdminUserProfile() {
  return (
    <div>
      <h1>UserProfile</h1>
    </div>
  )
}

export default AdminUserProfile
